<template>
    <new-modal
        :start-open="true"
        ref="classroomOnboardingModal"
        size="2xl"
        :show-header="false"
    >
        <template #content>
            <div class="mb-4">
                <div class="mb-4 flex flex-col gap-4">
                    <div class="font-semibold">
                        Ready to create a classroom?
                    </div>
                    <div class="text-gray-650">
                        Congrats, you've added a new student! You can now
                        organize your students through our “classrooms” feature.
                    </div>
                </div>

                <!-- step 1 -->
                <div v-if="step === 1" class="flex flex-col gap-4">
                    <div
                        class="relative flex flex-col gap-4 bg-gray-350 px-4 pt-4 text-center"
                    >
                        <div class="relative mx-auto w-16 font-semibold">
                            Step 1:
                            <span
                                class="absolute -bottom-2 left-0 right-0 mx-auto"
                            >
                                <svg
                                    class="mx-auto"
                                    width="49"
                                    height="7"
                                    viewBox="0 0 49 7"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <rect
                                        x="-0.0444336"
                                        y="3.76855"
                                        width="49"
                                        height="3"
                                        rx="1.5"
                                        transform="rotate(-4.13057 -0.0444336 3.76855)"
                                        fill="#0C71CF"
                                    />
                                </svg>
                            </span>
                        </div>
                        <div class="">
                            Select “classrooms” from the side navigation on
                            desktop or the hamburger menu on mobile
                        </div>
                        <div class="">
                            <img
                                src="/assets/art/onboarding1.png"
                                class="m-auto h-[300px] bg-gray-450"
                            />
                        </div>
                        <div
                            @click="step = 2"
                            class="absolute -right-4 top-[50%] flex h-8 w-8 items-center justify-center rounded rounded-full bg-black/50 bg-gray-500 hover:cursor-pointer hover:bg-black/75"
                        >
                            <svg
                                width="8"
                                height="14"
                                viewBox="0 0 8 14"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M1.25 12.5L6.75 7L1.25 1.5"
                                    stroke="white"
                                    stroke-width="1.83333"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                            </svg>
                        </div>
                    </div>
                    <div class="flex justify-center gap-1">
                        <div
                            class="h-2 w-2 rounded rounded-full bg-gray-500"
                        ></div>
                        <div
                            class="h-2 w-2 rounded rounded-full bg-gray-350"
                        ></div>
                        <div
                            class="h-2 w-2 rounded rounded-full bg-gray-350"
                        ></div>
                    </div>
                </div>
                <!-- step 2 -->
                <div v-if="step === 2" class="flex flex-col gap-4">
                    <div
                        class="relative flex flex-col gap-4 bg-gray-350 px-4 pt-4 text-center"
                    >
                        <div class="relative mx-auto w-16 font-semibold">
                            Step 2:
                            <span
                                class="absolute -bottom-2 left-0 right-0 mx-auto"
                            >
                                <svg
                                    class="mx-auto"
                                    width="49"
                                    height="7"
                                    viewBox="0 0 49 7"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <rect
                                        x="-0.0444336"
                                        y="3.76855"
                                        width="49"
                                        height="3"
                                        rx="1.5"
                                        transform="rotate(-4.13057 -0.0444336 3.76855)"
                                        fill="#0C71CF"
                                    />
                                </svg>
                            </span>
                        </div>
                        <div class="">
                            Create a classroom to manage cohorts of students
                            (e.g. “EMT's class of 2022”)
                        </div>
                        <div class="">
                            <img
                                src="/assets/art/onboarding2.png"
                                class="m-auto h-[300px] bg-gray-450"
                            />
                        </div>
                        <div
                            @click="step = 1"
                            class="absolute -left-4 top-[50%] flex h-8 w-8 items-center justify-center rounded rounded-full bg-black/50 bg-gray-500 hover:cursor-pointer hover:bg-black/75"
                        >
                            <svg
                                width="8"
                                height="14"
                                viewBox="0 0 8 14"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M6.75 12.5L1.25 7L6.75 1.5"
                                    stroke="white"
                                    stroke-width="1.83333"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                            </svg>
                        </div>
                        <div
                            @click="step = 3"
                            class="absolute -right-4 top-[50%] flex h-8 w-8 items-center justify-center rounded rounded-full bg-black/50 bg-gray-500 hover:cursor-pointer hover:bg-black/75"
                        >
                            <svg
                                width="8"
                                height="14"
                                viewBox="0 0 8 14"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M1.25 12.5L6.75 7L1.25 1.5"
                                    stroke="white"
                                    stroke-width="1.83333"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                            </svg>
                        </div>
                    </div>
                    <div class="flex justify-center gap-1">
                        <div
                            class="h-2 w-2 rounded rounded-full bg-gray-500"
                        ></div>
                        <div
                            class="h-2 w-2 rounded rounded-full bg-gray-500"
                        ></div>
                        <div
                            class="h-2 w-2 rounded rounded-full bg-gray-350"
                        ></div>
                    </div>
                </div>
                <!-- step 3 -->
                <div v-if="step === 3" class="flex flex-col gap-4">
                    <div
                        class="relative flex flex-col gap-4 bg-gray-350 px-4 pt-4 text-center"
                    >
                        <div class="relative mx-auto w-16 font-semibold">
                            Step 3:
                            <span
                                class="absolute -bottom-2 left-0 right-0 mx-auto"
                            >
                                <svg
                                    class="mx-auto"
                                    width="49"
                                    height="7"
                                    viewBox="0 0 49 7"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <rect
                                        x="-0.0444336"
                                        y="3.76855"
                                        width="49"
                                        height="3"
                                        rx="1.5"
                                        transform="rotate(-4.13057 -0.0444336 3.76855)"
                                        fill="#0C71CF"
                                    />
                                </svg>
                            </span>
                        </div>
                        <div class="">
                            Assign goals to your classrooms, and monitor your
                            students' scores and progress
                        </div>
                        <div class="">
                            <img
                                src="/assets/art/onboarding3.png"
                                class="m-auto h-[300px] bg-gray-450"
                            />
                        </div>
                        <div
                            @click="step = 2"
                            class="absolute -left-4 top-[50%] flex h-8 w-8 items-center justify-center rounded rounded-full bg-black/50 bg-gray-500 hover:cursor-pointer hover:bg-black/75"
                        >
                            <svg
                                width="8"
                                height="14"
                                viewBox="0 0 8 14"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M6.75 12.5L1.25 7L6.75 1.5"
                                    stroke="white"
                                    stroke-width="1.83333"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                            </svg>
                        </div>
                        <div
                            @click="step = 3"
                            class="absolute -right-4 top-[50%] flex h-8 w-8 items-center justify-center rounded rounded-full bg-black/50 bg-gray-500 hover:cursor-pointer hover:bg-black/75"
                        >
                            <svg
                                width="8"
                                height="14"
                                viewBox="0 0 8 14"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M1.25 12.5L6.75 7L1.25 1.5"
                                    stroke="white"
                                    stroke-width="1.83333"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                            </svg>
                        </div>
                    </div>
                    <div class="flex justify-center gap-1">
                        <div
                            class="h-2 w-2 rounded rounded-full bg-gray-500"
                        ></div>
                        <div
                            class="h-2 w-2 rounded rounded-full bg-gray-500"
                        ></div>
                        <div
                            class="h-2 w-2 rounded rounded-full bg-gray-500"
                        ></div>
                    </div>
                </div>
            </div>
            <div class="flex justify-center gap-2">
                <span class="btn btn-outline" @click="closeModal">Close</span>
                <button
                    class="btn btn-primary"
                    @click="gotoClassrooms()"
                    >Go to classrooms
                </button>
            </div>
        </template>
    </new-modal>
</template>
<script>
import NewModal from "@/Components/NewModal";

export default {
    name: "ClassroomOnboardingTour",
    components: {
        NewModal,
    },
    props: {
        step: {
            type: Number,
            default: 1,
        },
    },
    methods: {
        closeModal() {
            this.$refs.classroomOnboardingModal.closeModal();

            this.$inertia.post("dashboard", { setSeenTour: true });
        },
       async gotoClassrooms() {
            await this.$inertia.post("dashboard", { setSeenTour: true }, {onSuccess: () => {this.$inertia.visit(route('group.classrooms.index'), {preserveState: true})}});

            return true;
        }
    },
};
</script>
